export default "__VITE_ASSET__Bis9nNsY__"